module.exports = __webpack_public_path__ + "static/media/titulos.89b43403.svg";